import { cn } from "@omni/utils/styles";
import React, { HTMLAttributes } from "react";

export type RowProps = HTMLAttributes<HTMLDivElement> & {
    children?: React.ReactNode;
    className?: string;
    ref?: React.Ref<HTMLDivElement>;
};

const Row = ({ children, className, ...props }: RowProps) => {
    const classes = cn("tw:flex tw:flex-wrap tw:-mx-[1.4%]", className);

    return (
        <div
            className={classes}
            {...props}
        >
            {children}
        </div>
    );
};

export { Row };
